import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8cc4b19c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-market-list",
  "aria-labelledby": "mobile-market-title"
};
const _hoisted_2 = {
  class: "market-board"
};
const _hoisted_3 = {
  class: "market-top"
};
const _hoisted_4 = {
  class: "market-heading"
};
const _hoisted_5 = {
  id: "mobile-market-title"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ".", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "→", -1));

const _hoisted_8 = ["aria-label"];
const _hoisted_9 = ["aria-pressed", "onClick"];
const _hoisted_10 = {
  key: 0,
  class: "market-grid"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "asset-icon"
};
const _hoisted_13 = {
  class: "asset-initial"
};
const _hoisted_14 = ["src", "onError"];
const _hoisted_15 = {
  class: "asset-name"
};
const _hoisted_16 = {
  class: "asset-price"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "USDT", -1));

const _hoisted_18 = {
  key: 1,
  class: "market-empty"
};
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import { fmtImageSrc } from '@/util';
import { getHomePageCopy } from '@/util/homePageCopy';
export default {
  __name: 'HomeMarketList',

  setup(__props) {
    const router = useRouter();
    const {
      locale
    } = useI18n();
    const activeTab = ref('popular');
    const failedIcons = ref(new Set());
    const copy = computed(() => getHomePageCopy(locale.value).market);
    const numberLocales = {
      ar: 'ar',
      de: 'de-DE',
      en: 'en-US',
      fr: 'fr-FR',
      hin: 'hi-IN',
      it: 'it-IT',
      jp: 'ja-JP',
      kr: 'ko-KR',
      nl: 'nl-NL',
      pt: 'pt-PT',
      ru: 'ru-RU',
      span: 'es-ES',
      tc: 'zh-TW',
      th: 'th-TH',
      tr: 'tr-TR'
    };
    const numberLocale = computed(() => numberLocales[locale.value] || 'en-US');
    const tabs = computed(() => [{
      id: 'popular',
      label: copy.value.tabs.popular
    }, {
      id: 'gainers',
      label: copy.value.tabs.gainers
    }, {
      id: 'losers',
      label: copy.value.tabs.losers
    }]);
    const availableKeys = computed(() => {
      const keys = store.state.marketCoinKey?.length ? store.state.marketCoinKey : store.state.homeKey;
      return (keys || []).filter(key => store.state.marketInfo[key]);
    });
    const marketCount = computed(() => availableKeys.value.length);
    const markets = computed(() => availableKeys.value.map(key => {
      const info = store.state.marketInfo[key] || {};
      const quote = store.state.market[key] || {};
      return {
        key,
        name: info.name || info.stock || key,
        icon: info.icon,
        decimals: Number(info.decimal),
        price: Number(quote.last),
        change: Number(quote.growth)
      };
    }));
    const visibleMarkets = computed(() => {
      if (activeTab.value === 'popular') return markets.value.slice(0, 8);
      const priced = markets.value.filter(item => Number.isFinite(item.price) && item.price > 0 && Number.isFinite(item.change));
      if (activeTab.value === 'gainers') return priced.filter(item => item.change > 0).sort((a, b) => b.change - a.change).slice(0, 8);
      return priced.filter(item => item.change < 0).sort((a, b) => a.change - b.change).slice(0, 8);
    });

    function formatPrice(item) {
      if (!Number.isFinite(item.price) || item.price <= 0) return '—';
      const decimals = Number.isFinite(item.decimals) ? Math.max(2, Math.min(item.decimals, 8)) : 6;
      const minimum = item.price >= 1 ? 2 : Math.min(decimals, item.price >= .01 ? 4 : 6);
      return new Intl.NumberFormat(numberLocale.value, {
        minimumFractionDigits: minimum,
        maximumFractionDigits: decimals
      }).format(item.price);
    }

    function formatChange(item) {
      if (!Number.isFinite(item.price) || item.price <= 0 || !Number.isFinite(item.change)) return '—';
      return `${new Intl.NumberFormat(numberLocale.value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        signDisplay: item.change > 0 ? 'always' : 'auto'
      }).format(item.change)}%`;
    }

    const changeClass = item => ({
      rising: item.price > 0 && item.change > 0,
      falling: item.price > 0 && item.change < 0
    });

    const markIconFailed = key => {
      failedIcons.value = new Set([...failedIcons.value, key]);
    };

    const openMarket = key => router.push({
      name: 'futures',
      query: {
        key: store.state.marketInfo[key]?.coin || key
      }
    });

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, [_createTextVNode(_toDisplayString(_unref(copy).title), 1), _hoisted_6]), _createElementVNode("p", null, _toDisplayString(_unref(copy).description), 1)]), _createElementVNode("button", {
        class: "market-all-link",
        type: "button",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
          name: 'futures'
        }))
      }, [_createTextVNode(_toDisplayString(_unref(copy).viewAll) + " ", 1), _hoisted_7])]), _createElementVNode("div", {
        class: "market-tabs",
        role: "group",
        "aria-label": _unref(copy).view
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), tab => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.id,
          type: "button",
          class: _normalizeClass({
            active: activeTab.value === tab.id
          }),
          "aria-pressed": activeTab.value === tab.id,
          onClick: $event => activeTab.value = tab.id
        }, _toDisplayString(tab.label), 11, _hoisted_9);
      }), 128))], 8, _hoisted_8), _unref(visibleMarkets).length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleMarkets), item => {
        return _openBlock(), _createElementBlock("button", {
          key: item.key,
          class: "market-row",
          type: "button",
          onClick: $event => openMarket(item.key)
        }, [_createElementVNode("span", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(item.name.slice(0, 1)), 1), item.icon && !failedIcons.value.has(item.key) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(fmtImageSrc)(item.icon),
          alt: "",
          onError: $event => markIconFailed(item.key)
        }, null, 40, _hoisted_14)) : _createCommentVNode("", true)]), _createElementVNode("strong", _hoisted_15, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_16, [_createElementVNode("strong", null, _toDisplayString(formatPrice(item)), 1), _hoisted_17]), _createElementVNode("span", {
          class: _normalizeClass(["asset-change", changeClass(item)])
        }, _toDisplayString(formatChange(item)), 3)], 8, _hoisted_11);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(marketCount) ? _unref(copy).noPriceChanges : _unref(copy).dataPending), 1))])]);
    };
  }

};